module.exports = __webpack_public_path__ + "static/inductor-411e4e7933e7e2f63ca7c632cf0f1c91.jpg";